// extracted by mini-css-extract-plugin
export default {"subjectBox":"SubjectBox_subjectBox__UJFt3"};